import { render, staticRenderFns } from "./IsardImage.vue?vue&type=template&id=0b5b3660&"
import script from "./IsardImage.vue?vue&type=script&lang=js&"
export * from "./IsardImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports